import { useCallback, useState } from 'react';

/** @typedef {'wall' | 'point' | 'opening'} FloorPlanHoverKind */

/**
 * @typedef {{ kind: FloorPlanHoverKind; id: string }} FloorPlanHoverTarget
 */

export function useFloorPlanHover() {
  const [hoverTarget, setHoverTarget] = useState(
    /** @type {FloorPlanHoverTarget | null} */ (null),
  );

  const setHover = useCallback(
    /**
     * @param {FloorPlanHoverKind | null} kind
     * @param {string | null} [id]
     */
    (kind, id = null) => {
      if (!kind || !id) {
        setHoverTarget(null);
        return;
      }
      setHoverTarget({ kind, id });
    },
    [],
  );

  const clearHover = useCallback(() => {
    setHoverTarget(null);
  }, []);

  const isHovered = useCallback(
    /**
     * @param {FloorPlanHoverKind} kind
     * @param {string} id
     */
    (kind, id) => hoverTarget?.kind === kind && hoverTarget?.id === id,
    [hoverTarget],
  );

  return { hoverTarget, setHover, clearHover, isHovered };
}
